/* eslint-disable prefer-const */
/* eslint react/prop-types: off, react/display-name: off */
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Row, Card } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import DataTable from "components/organisms/DataTable/DataTable";
import { useColumnOrder, useSortBy, useTable } from "react-table";
import { useParams } from "react-router-dom";

import "./ShipmentAuditTrail.scss";
import { replaceEmails } from "helpers/urlHelpers";
import { useGetAuditTrail } from "api/queries/quotes/useGetAuditTrail";
import { DateTimeFormat, formatDate } from "helpers/dateTimeHelper";

// defining outside for stable reference across re-renders
const initialData: any = [];
const ShipmentAuditTrail = function () {
  const { id: shipmentId } = useParams();
  let { data = initialData, isLoading } = useGetAuditTrail({ shipmentId } as any);

  const columns = useMemo(
    () => [
      {
        Header: (
          <span className="pl-9">
            <FormattedMessage id="audit-trail.timestamp" defaultMessage="Timestamp" />
          </span>
        ),
        accessor: "timestamp",
        Cell: ({ value }: any) => (
          <p className="pl-9 pt-8 pb-8 mb-0">{formatDate(value, DateTimeFormat.fullDateTimeFormat)}</p>
        ),
      },
      {
        Header: <FormattedMessage id="audit-trail.company" defaultMessage="Company" />,
        accessor: "company",
        Cell: ({ value }: any) => <p className="pt-8 pb-8 mb-0">{value}</p>,
      },
      {
        Header: (
          <span className="mb-0">
            <FormattedMessage id="audit-trail.actor" defaultMessage="Actor" />
          </span>
        ),
        accessor: "actor",
        Cell: ({ value, row }: any) => {
          const actor_email = row?.original?.actor_email;
          return (
            <div className="pt-8 pb-8">
              <div>{value}</div>
              {actor_email && (
                <a href={`mailto:${actor_email}`}>
                  <pre className="mb-0 mt-xxs text-blue">{row?.original?.actor_email}</pre>
                </a>
              )}
            </div>
          );
        },
      },
      {
        Header: (
          <span className="mb-0 text-right">
            <FormattedMessage id="audit-trail.action" defaultMessage="Action" />
          </span>
        ),
        accessor: "action",
        Cell: ({ value }: any) => {
          const [beforeFile, afterFile] = value.split("file: ");
          return (
            <div className="pt-8 pb-8">
              <pre className="mb-0">
                {ReactHtmlParser(replaceEmails(beforeFile))}
                {afterFile && (
                  <>
                    file:{" "}
                    <a href={afterFile} rel="noopener noreferrer" target="_blank">
                      {afterFile}
                    </a>
                  </>
                )}
              </pre>
            </div>
          );
        },
      },
    ],
    [],
  );

  const instance = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    useColumnOrder,
  );

  return (
    <Row className="ml-0 mr-0">
      <Card body className="shadow-none w-100 audit-trail-container">
        <DataTable tableInstance={instance} isLoading={isLoading} withoutBody draggable={false} />
      </Card>
    </Row>
  );
};

export default ShipmentAuditTrail;
